const QIcon = ({ width = 18, height = 22 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 120"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#E07A76"
        fillRule="evenodd"
        d="
          M30.70,4.19
          L23.03,9.93
          L18.20,15.00
          L13.16,21.84
          L9.87,27.35
          L8.99,29.78
          L8.33,30.22
          L6.80,34.63
          L6.14,35.07
          L3.29,43.01
          L3.07,45.00
          L2.41,45.88
          L2.41,47.65
          L1.75,48.31
          L1.75,50.74
          L1.10,51.62
          L0.88,54.93
          L0.00,57.35
          L0.00,78.53
          L0.66,79.41
          L0.66,82.06
          L1.32,83.16
          L1.97,87.13
          L5.48,95.29
          L11.62,103.68
          L16.89,108.09
          L22.15,111.18
          L30.70,114.26
          L37.06,115.15
          L46.49,114.93
          L47.59,114.26
          L49.78,114.26
          L57.89,111.18
          L61.84,108.97
          L68.64,103.90
          L77.85,115.15
          L83.77,118.46
          L87.50,119.34
          L87.72,119.78
          L96.27,119.78
          L99.34,118.46
          L99.78,117.35
          L98.68,115.37
          L80.26,91.10
          L85.75,81.84
          L90.57,69.49
          L90.57,68.16
          L91.23,67.28
          L92.98,58.46
          L93.42,41.47
          L92.76,35.51
          L92.11,34.19
          L91.23,28.68
          L87.50,19.85
          L82.24,12.79
          L77.63,8.60
          L70.83,4.19
          L64.04,1.32
          L62.50,1.32
          L61.18,0.44
          L58.55,0.00
          L42.11,0.00
          L35.09,1.99
          Z
          M60.09,11.03
          L64.91,13.24
          L68.42,16.32
          L71.71,21.84
          L73.25,27.13
          L73.25,30.66
          L73.90,31.99
          L73.46,47.87
          L70.18,62.87
          L65.79,72.79
          L64.69,72.13
          L63.16,69.71
          L57.89,63.75
          L53.73,62.21
          L50.66,61.76
          L46.71,62.21
          L44.30,63.75
          L42.98,65.96
          L43.64,69.04
          L56.36,86.69
          L56.36,87.35
          L50.88,93.31
          L42.54,99.49
          L35.75,102.35
          L31.80,103.01
          L27.85,102.79
          L26.32,102.13
          L24.12,100.15
          L22.37,97.50
          L20.61,92.87
          L19.30,86.25
          L19.08,69.71
          L20.83,57.35
          L24.12,45.22
          L28.07,35.51
          L32.02,28.46
          L36.18,22.50
          L41.67,16.76
          L46.49,13.24
          L49.78,11.69
          L55.26,10.81
          Z
        "
      />
    </svg>
  );
};

export default QIcon;
